const initialValues = (firstName, lastName) => ({
    FirstName: firstName,
    LastName: lastName,
    Password: '',
});
export default initialValues;
